@if (item && item.items) {
  <div class="pane-wrapper">
    <div
      class="pane bg-white border-r border-gray-300 scrollable-y scrollbar-thin scrollbar-thumb-blue-200 scrollbar-thumb-rounded-md scrollbar-track-blue-50 hover:scrollbar-thumb-blue-200"
    >
      @if (isMultiSelect) {
        <div
          class="w-full h-10 flex items-center px-3 text-gray-900 bg-white hover:bg-gray-50 active:bg-gray-200 cursor-pointer border-b border-gray-300"
        >
          <mat-checkbox
            [indeterminate]="isIndeterminate"
            [checked]="isSelectAllChecked"
            (change)="selectAllCheckboxChanged($event)"
            labelPosition="after"
            ><span class="ml-2 text-base md:text-sm text-gray-900 font-medium">Select all</span>
          </mat-checkbox>
        </div>
      }
      @if (itemsList && itemsList.length) {
        @for (item of itemsList; track item) {
          <div
            class="panel-option w-full h-10 flex items-center px-3 py-3 text-gray-900 font-medium cursor-pointer border-b border-gray-300"
            [ngClass]="{ active: selectedItem?.label === item.label }"
            (click)="containerItemSelected(item)"
          >
            <div class="flex-1 truncate" [title]="item.label">{{ item.label }}</div>
            <app-continuation-indicator [isActive]="selectedItem?.label === item.label"></app-continuation-indicator>
          </div>
        }
      }
      @if (checkableItemsList && checkableItemsList.length) {
        <mat-selection-list
          class="filter-item-select-list"
          #selectList
          [(ngModel)]="selectedCheckableItems"
          (selectionChange)="checkableItemsChanged($event)"
        >
          @for (item of checkableItemsList; track item; let idx = $index; let first = $first; let last = $last) {
            <mat-list-option checkboxPosition="before" [value]="item" class="select-list-item">
              <div class="flex-1 truncate text-base md:text-sm text-gray-900 font-medium" [title]="item.label">
                {{ item.label }}
              </div>
              <!-- <app-continuation-indicator [isActive]="selectedFacetOption && selectedFacetOption.label === facet.label"
              [facet]="facet"
              [parentData]="facetData">
            </app-continuation-indicator> -->
            </mat-list-option>
          }
        </mat-selection-list>
      }
    </div>
  </div>
} @else {
  <div class="w-full h-full flex items-center justify-items-center">No Facet Data!!</div>
}
